var exports = {
  "a": "Box__nP_d2G",
};

module.exports = exports;
